import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-register-success',
  templateUrl: './register-success.component.html',
  styleUrls: ['./register-success.component.scss']
})
export class RegisterSuccessComponent implements OnInit{

  ngOnInit() {
    localStorage.removeItem('form')
  }
}
